var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85429 9.70857C5.90847 9.70857 6.88059 9.3677 7.67596 8.79958L10.6681 11.7917C10.8069 11.9306 10.99 12 11.1857 12C11.596 12 11.8864 11.6844 11.8864 11.2804C11.8864 11.091 11.8233 10.9079 11.6844 10.7754L8.7112 7.7959C9.33614 6.97528 9.70857 5.95897 9.70857 4.85429C9.70857 2.18411 7.52446 0 4.85429 0C2.19043 0 0 2.1778 0 4.85429C0 7.52446 2.18411 9.70857 4.85429 9.70857ZM4.85429 8.6607C2.77117 8.6607 1.04787 6.9374 1.04787 4.85429C1.04787 2.77117 2.77117 1.04787 4.85429 1.04787C6.9374 1.04787 8.6607 2.77117 8.6607 4.85429C8.6607 6.9374 6.9374 8.6607 4.85429 8.6607ZM3.23198 5.3151H6.47659C6.72909 5.3151 6.9374 5.10679 6.9374 4.85429C6.9374 4.60179 6.72909 4.38716 6.47659 4.38716H3.23198C2.97948 4.38716 2.76486 4.60179 2.76486 4.85429C2.76486 5.10679 2.97948 5.3151 3.23198 5.3151Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.a79afa373d1040eed00bb9842dfa6f3c.svg";
export { ForwardRef as ReactComponent };